import { useEffect } from 'react';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

NProgress.configure({ 
    showSpinner: false,
    minimum: 0.3,
    trickleSpeed: 200
});

export const useNProgressLoader = () => {
    useEffect(() => {
        const interceptRequest = async () => {
            NProgress.start();
        };

        const interceptResponse = async () => {
            NProgress.done();
        };

        // Add event listeners for API calls
        window.addEventListener('apiRequest', interceptRequest);
        window.addEventListener('apiResponse', interceptResponse);

        return () => {
            window.removeEventListener('apiRequest', interceptRequest);
            window.removeEventListener('apiResponse', interceptResponse);
            NProgress.done();
        };
    }, []);
};